/**
 * Returns the health score grade for a given health score
 *
 * @param {number | undefined} score - the health score
 * @returns {string} - the health score grade
 */
function getHealthScoreGrade(score: number | undefined): string {
  if (!score) {
    return '-';
  }

  switch (true) {
    case score === -1:
      return '-';
    case score < 50:
      return 'F';
    case score < 64:
      return 'D-';
    case score < 67:
      return 'D';
    case score < 70:
      return 'D+';
    case score < 74:
      return 'C-';
    case score < 77:
      return 'C';
    case score < 80:
      return 'C+';
    case score < 84:
      return 'B-';
    case score < 87:
      return 'B';
    case score < 90:
      return 'B+';
    case score < 94:
      return 'A-';
    case score < 100:
      return 'A';
    default:
      return 'A+';
  }
}

export { getHealthScoreGrade };
